// extracted by mini-css-extract-plugin
export default {"cardTitle":"style_cardTitle__1kQZY","cabecalho":"style_cabecalho__daWX4","separador":"style_separador__ZpCWQ"};